import React from 'react';
import MuiRadio, { RadioProps } from '@mui/material/Radio';
import { radioSx } from './Radio.styles';
import { SxProps, Theme } from '@mui/material/styles';

export const Radio = React.forwardRef<HTMLButtonElement, RadioProps>((props, ref) => {
  return (
    <MuiRadio
      ref={ref}
      {...props}
      sx={[radioSx, props.sx] as SxProps<Theme>}
    />
  );
});

Radio.displayName = 'Radio';